import { z } from 'zod';
import { Callout } from '../../../__types__/v1/models/Callout';

export const calloutMetadata$ = z
  .object({
    useNewForm: z.boolean().optional(),
    terms: z
      .object({
        enabled: z.boolean(),
        title: z.string(),
        content: z.string(),
        checkboxLabel: z.string()
      })
      .partial()
      .optional()
  })
  .passthrough();

export const callout$ = z.object({
  id: z.number(),
  guid: z.string(),
  public_id: z.string().nullable(),
  slug: z.string().nullable(),
  status: z.enum(['BUILDING', 'PUBLISHED']).nullable(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  public_title: z.string().nullable(),
  public_description: z.string().nullable(),
  mappings: z.array(z.any()).nullable(),
  confirmation_text: z.string().nullable(),
  private_password: z.string().nullable(),
  enable_notifications: z.boolean().nullable(),
  published: z.boolean().nullable(),
  deadline: z.string().nullable(),
  published_at: z.string().nullable(),
  resource_type_id: z.number().nullable(),
  enterprise_workspace_id: z.number().nullish(),
  tasklist_id: z.number().nullable(),
  archived: z.boolean(),
  user_id: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  created_mechanism: z.string().nullable(),
  metadata: calloutMetadata$.nullable().optional()
});

export const calloutAssociations$ = z.object({
  id: z.number(),
  applicants: z.array(
    z.object({
      id: z.number(),
      callout_id: z.number(),
      contact_id: z.number().nullable(),
      contact: z.any().nullable(),
      archived: z.boolean(),
      created_at: z.string(),
      updated_at: z.string(),
      data: z
        .record(z.string(), z.any())
        .nullable()
        .transform(value => value ?? {}),
      source_ip: z.string().nullable()
    })
  )
});

export const calloutBatchAssociations$ = z.array(calloutAssociations$);

export function calloutFromHttp(http: z.infer<typeof callout$>): Callout {
  return {
    id: http.id,
    guid: http.guid,
    public_id: http.public_id || undefined,
    slug: http.slug || undefined,
    status: http.status || undefined,
    title: http.title || undefined,
    description: http.description || undefined,
    public_title: http.public_title || undefined,
    public_description: http.public_description || undefined,
    mappings: http.mappings || undefined,
    confirmation_text: http.confirmation_text || undefined,
    private_password: http.private_password || undefined,
    enable_notifications: http.enable_notifications || undefined,
    published: http.published || undefined,
    deadline: http.deadline ? new Date(http.deadline) : undefined,
    published_at: http.published_at ? new Date(http.published_at) : undefined,
    resource_type_id: http.resource_type_id || undefined,
    enterprise_workspace_id: http.enterprise_workspace_id ?? undefined,
    tasklist_id: http.tasklist_id || undefined,
    archived: http.archived,
    user_id: http.user_id,
    created_at: new Date(http.created_at),
    updated_at: new Date(http.updated_at),
    created_mechanism: http.created_mechanism || null,
    metadata: http.metadata ?? undefined
  };
}
